import mlApi from '@/api/ml';
import apicaller from '@/utils/apicaller';
import api from '@/main.api';

const FP_STATES_KEY = 'mlAnalysisFpStates';
const REAL_STATES_KEY = 'mlAnalysisRealStates';

function readStoredStates(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

const state = () => ({
  summary: null,
  summaryLoading: false,
  breakdown: [],
  breakdownLoading: false,
  timeline: [],
  timelineLoading: false,
  timelineDays: 30,
  evaluations: { items: [], totalCount: 0, page: 0, pageSize: 20 },
  evaluationsLoading: false,
  effectiveness: null,
  effectivenessLoading: false,
  alertStates: [],
  fpStates: readStoredStates(FP_STATES_KEY),
  realStates: readStoredStates(REAL_STATES_KEY),
  deepEval: null,
  deepEvalLoading: false,
});

const mutations = {
  SET(state, { key, val }) {
    state[key] = val;
  },
  SET_STATE_SELECTION(state, { fpStates, realStates }) {
    state.fpStates = fpStates;
    state.realStates = realStates;
    localStorage.setItem(FP_STATES_KEY, JSON.stringify(fpStates));
    localStorage.setItem(REAL_STATES_KEY, JSON.stringify(realStates));
  },
};

const actions = {
  loadSummary({ commit }) {
    commit('SET', { key: 'summaryLoading', val: true });
    mlApi.getAnalysisSummary()
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200) {
          commit('SET', { key: 'summary', val: resp.data.result });
        }
      })
      .catch(error => {
        console.error('loadSummary hata:', error);
      })
      .finally(() => {
        commit('SET', { key: 'summaryLoading', val: false });
      });
  },

  loadBreakdown({ commit }) {
    commit('SET', { key: 'breakdownLoading', val: true });
    mlApi.getAnalysisScenarioBreakdown()
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200) {
          commit('SET', { key: 'breakdown', val: resp.data.result || [] });
        }
      })
      .catch(error => {
        console.error('loadBreakdown hata:', error);
      })
      .finally(() => {
        commit('SET', { key: 'breakdownLoading', val: false });
      });
  },

  loadTimeline({ commit, state }, days) {
    const selectedDays = days || state.timelineDays;
    commit('SET', { key: 'timelineDays', val: selectedDays });
    commit('SET', { key: 'timelineLoading', val: true });
    mlApi.getAnalysisTimeline(selectedDays)
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200) {
          commit('SET', { key: 'timeline', val: resp.data.result || [] });
        }
      })
      .catch(error => {
        console.error('loadTimeline hata:', error);
      })
      .finally(() => {
        commit('SET', { key: 'timelineLoading', val: false });
      });
  },

  loadEvaluations({ commit, state }, { page, pageSize } = {}) {
    const selectedPage = page === undefined ? state.evaluations.page : page;
    const selectedSize = pageSize === undefined ? state.evaluations.pageSize : pageSize;
    commit('SET', { key: 'evaluationsLoading', val: true });
    mlApi.getAnalysisEvaluations(selectedPage, selectedSize)
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200 && resp.data.result) {
          commit('SET', { key: 'evaluations', val: resp.data.result });
        }
      })
      .catch(error => {
        console.error('loadEvaluations hata:', error);
      })
      .finally(() => {
        commit('SET', { key: 'evaluationsLoading', val: false });
      });
  },

  loadAlertStates({ commit }) {
    apicaller.get(api.MANAGEMENT.scenarioAlertStates.getScenarioAlertStates)
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200) {
          commit('SET', { key: 'alertStates', val: resp.data.result || [] });
        }
      })
      .catch(error => {
        console.error('loadAlertStates hata:', error);
      });
  },

  setStateSelection({ commit }, { fpStates, realStates }) {
    commit('SET_STATE_SELECTION', { fpStates, realStates });
  },

  clearDeepEval({ commit }) {
    commit('SET', { key: 'deepEval', val: null });
  },

  loadEffectiveness({ commit, state }) {
    if (!state.fpStates.length && !state.realStates.length) {
      commit('SET', { key: 'effectiveness', val: null });
      return;
    }
    commit('SET', { key: 'effectivenessLoading', val: true });
    mlApi.getAnalysisEffectiveness({
      falsePositiveStates: state.fpStates,
      realAlarmStates: state.realStates,
    })
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200) {
          commit('SET', { key: 'effectiveness', val: resp.data.result });
        }
      })
      .catch(error => {
        console.error('loadEffectiveness hata:', error);
      })
      .finally(() => {
        commit('SET', { key: 'effectivenessLoading', val: false });
      });
  },

  runDeepEval({ commit }, { modelId, validationSql }) {
    commit('SET', { key: 'deepEvalLoading', val: true });
    return mlApi.deepEvaluateModel({ modelId, validationSql: validationSql || null })
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200) {
          commit('SET', { key: 'deepEval', val: resp.data.result });
        }
        return resp;
      })
      .catch(error => {
        console.error('runDeepEval hata:', error);
      })
      .finally(() => {
        commit('SET', { key: 'deepEvalLoading', val: false });
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
